/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type CookieInformationPageContentModelContentType = typeof CookieInformationPageContentModelContentType[keyof typeof CookieInformationPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CookieInformationPageContentModelContentType = {
  cookieInformationPage: 'cookieInformationPage',
} as const;
